<template>
    <div>
        <div class="craft">
            <div class="part-one">
                <div class="base-title">
                    <div class="part-one-content">
                        <img class="part-one-title-img" src="../assets/imgs/craft/part-1-title.png" alt="" />
                        <div class="part-text part-one-text">
                            为鼓励企业引进和培育急需紧缺技能人才，按照“人才新政12条”“人才新政3.0版”，对企业新培育、符合条件的技能人才发放技能提升奖励。
                        </div>
                    </div>
                </div>
            </div>
            <div class="part-two">
                <img src="../assets/imgs/craft/part-2-title.png" class="part-two-title-img" />
                <div class="part-title part-two-title" style="margin-top: 1.44rem">
                    需同时满足以下条件：
                </div>
                <div class="part-two-content">
                    <div v-for="item in part2" :key="item.id" style="margin-bottom: 0.22rem; position: relative">
                        <div class="part-two-dot">{{ item.id }}</div>
                        {{ item.text }}
                    </div>
                </div>
            </div>
            <div class="part-three">
                <img src="../assets/imgs/craft/part-3-title.png" class="part-two-title-img" />
                <div class="part-three-items">
                    <div class="part-text" v-for="item in part3" :key="item.id" style="margin-bottom: 0.4rem">
                        {{ item.text }}
                    </div>
                </div>
            </div>
            <div class="part-four">
                <img src="../assets/imgs/craft/part-4-title.png" class="part-two-title-img" />
                <div class="part-title part-four-title">
                    按照“随时申请，及时办理、现场办结”原则。
                </div>
                <div class="main-content">
                    <div class="part-four-items" v-for="item in part4" :key="item.id" :style="item.boxHeight">
                        <div :class="item.title">{{ item.label }}</div>
                        <div class="part-four-content1">
                            <span class="inside-title" v-if="item.content1.title">{{ item.content1.title }}</span>
                            {{ item.content1.text }}
                        </div>
                        <div class="part-four-content2" v-if="item.content2">
                            <div v-for="(item2, index2) in item.content2" :key="index2">
                                {{ item2 }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="contact">
                <img class="top" src="./../assets/imgs/label/contact4.png" alt="" />
                <div class="content">
                    <div class="number">
                        <span class="label">政策咨询电话：</span>
                        <div>
                            <a href="tel:028-61888231">028-61888231</a>
                        </div>
                    </div>
                    <div class="unit">
                        <span class="label">责任单位：</span>
                        成都市人力资源和社会保障局职业能力建设处
                    </div>
                </div>
            </div>
            <div class="part-five">申请时间：全年</div>
            <!-- <div class="bottom-info">
                责任单位：成都市人力资源和社会保障局职业能力建设处
            </div>
            <div class="bottom-info" style="margin-top: 0.15rem">
                咨询电话:<a
                    href="tel:028-61888231"
                    >028-61888231</a
                >
            </div> -->
            <!-- <bottom
                    phone="028-61888231"
                    unit="成都市人力资源和社会保障局职业能力建设处"
                ></bottom> -->
        </div>
        <call phone="028-61888231"></call>
    </div>
</template>

<script>
// import bottom from "../components/bottom.vue";
import call from "../components/call.vue";

export default {
    name: "craft",
    components: {
        // bottom,
        call,
    },
    data() {
        return {
            part2: [
                {
                    id: 1,
                    text: "在成都市各类企业、社会团体、民办非企业、职业（技工）院校和职业技能培训机构等用人单位参保的技能人才（包括依法累计参加失业保险1年以上的在职职工、以及在本市领取失业保险期间的失业人员）。",
                },
                {
                    id: 2,
                    text: "属于《国家职业分类大典》第四、五、六类人员中，掌握专门知识和技术，具备一定操作技能，在工作实践中能够运用自己技术和能力进行实际操作，取得初级工、中级工、高级工、技师和高级技师等国家职业资格证书或职业技能等级证书，以及其他具备相应职业技能水平的人员。",
                },
            ],
            part3: [
                {
                    id: 1,
                    text: "（一）取得初级工（五级），可申领1000元技能提升补贴。",
                },
                {
                    id: 2,
                    text: "（二）取得中级工（四级），可申领1500元技能提升补贴。",
                },
                {
                    id: 3,
                    text: "（三）取得高级工（三级），可申领2000元技能提升补贴。",
                },
            ],
            part4: [
                {
                    id: 11,
                    title: "title-bg",
                    label: "提交材料",
                    content1: {
                        title: "",
                        text: "由技能人才向失业保险参保所在地公共就业服务机构提出申请，提交以下材料：",
                    },
                    content2: [
                        "1．失业保险支持技能提升补贴申请表；",
                        "2．国家职业资格证书原件及复印件；",
                        "3．身份证原件及复印件。",
                    ],
                    boxHeight: "",
                },
                {
                    id: 21,
                    label: "经办机构现场审核，作出审核结论。",
                    title: "title-bg title-bg2",
                    content1: {
                        title: "",
                        text: "",
                    },
                    content2: "",
                    boxHeight: "margin-bottom:0;border:none",
                },
            ],
        };
    },
    created() { },
    mounted() { },
    computed: {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.craft {
    background: #0839b7;
    overflow: hidden;
    padding: 0.24rem 0.12rem;
    padding-bottom: 1.65rem;
    box-sizing: border-box;
    width: 100vw;
    height: 100vh;
    overflow-y: auto;

    .part-title {
        font-size: 0.34rem;
        // //font-family:: PingFang SC-Bold, PingFang SC;
        font-weight: bold;
        color: #333333;
        position: relative;

        &::before {
            position: absolute;
            content: "";
            width: 0.28rem;
            height: 0.28rem;
            border-radius: 50%;
            background: none;
            border: 0.06rem solid #ff6d60;
            box-sizing: border-box;
            top: 0.08rem;
            left: -0.2rem;
        }
    }

    .part-text {
        font-size: 0.26rem;
        // //font-family:: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #4e4e4e;
        line-height: 0.44rem;
        text-align: left;
    }

    .part-one {
        height: 7.1rem;
        width: 7.5rem;
        margin: 0 auto;

        .base-title {
            width: 7.26rem;
            height: 5.6rem;
            background: url(../assets/imgs/17/base-title.png);
            background-size: 100% 100%;
            position: relative;

            .part-one-content {
                width: 6.85rem;
                background: #ffffff;
                border-radius: 10px;
                position: absolute;
                top: 4.02rem;
                left: 0.22rem;
                padding-left: 0.36rem;
                padding-right: 0.37rem;
                box-sizing: border-box;
                padding-bottom: 0.35rem;

                .part-one-title-img {
                    position: absolute;
                    top: -0.32rem;
                    left: 0;
                    width: 6.86rem;
                    height: 1.12rem;
                }

                .part-one-text {
                    margin-top: 1.2rem;
                }
            }
        }
    }

    .part-two-title-img {
        width: 7.03rem;
        height: 1.37rem;
        top: 0;
        left: -0.18rem;
        position: absolute;
    }

    .part-two {
        margin-left: 0.02rem;
        width: 6.85rem;
        margin-top: 0.22rem;
        background: #e8eeff;
        // height: 7.85rem;
        border-radius: 10px;
        padding-left: 0.33rem;
        padding-right: 0.3rem;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 0.22rem;
        border: 0.00001px solid transparent;
        position: relative;

        .part-two-title {
            text-align: left;
            margin-left: 0.33rem;

            &::before {
                position: absolute;
                content: "";
                width: 0.28rem;
                height: 0.28rem;
                border-radius: 50%;
                background: none;
                border: 0.06rem solid #ff6d60;
                box-sizing: border-box;
                top: 0.08rem;
                left: -0.35rem;
            }
        }

        .part-two-content {
            margin-top: 0.2rem;
            margin-bottom: 0.3rem;
            width: 6.22rem;
            // height: 5.4rem;
            background: #ffffff;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 0.34rem 0.24rem 0.3rem 0.67rem;
            font-size: 0.26rem;
            // //font-family:: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #4e4e4e;
            line-height: 0.44rem;
            text-align: left;

            .part-two-dot {
                position: absolute;
                top: 0;
                left: -0.46rem;
                width: 0.36rem;
                height: 0.36rem;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                color: #fff;
                font-size: 0.26rem;
                background: #739bfe;
                border-radius: 50%;
            }
        }
    }

    .part-three {
        width: 6.85rem;
        background: #e8eeff;
        border-radius: 10px;
        margin-left: 0.02rem;
        margin-top: 0.22rem;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 0.22rem;
        border: 0.00001px solid transparent;
        position: relative;
        padding: 1.5rem 0.25rem 0 0.25rem;

        .part-three-items {
            width: 6.35rem;
            // height: 4.24rem;
            background: #ffffff;
            border-radius: 10px;
            padding: 0.31rem;
            padding-bottom: 0.32rem;
            box-sizing: border-box;
            position: relative;
            margin-bottom: 0.22rem;
        }
    }

    .part-four {
        width: 6.85rem;
        background: #e8eeff;
        border-radius: 10px;
        margin-left: 0.02rem;
        margin-top: 0.22rem;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 0.22rem;
        border: 0.00001px solid transparent;
        position: relative;
        padding: 1.4rem 0.25rem 0.35rem 0.25rem;

        .part-four-title {
            text-align: left;
            margin-left: 0.5rem;

            &::before {
                position: absolute;
                content: "";
                width: 0.28rem;
                height: 0.28rem;
                border-radius: 50%;
                background: none;
                border: 0.06rem solid #ff6d60;
                box-sizing: border-box;
                top: 0.08rem;
                left: -0.38rem;
            }
        }

        .main-content {
            margin-top: 0.34rem;
            width: 6.35rem;
            background: #ffffff;
            border-radius: 10px;
            box-sizing: border-box;
            padding-top: 0.9rem;
            padding-left: 0.35rem;
            padding-right: 0.31rem;

            .part-four-items {
                box-sizing: border-box;
                border-left: 0.02rem dashed #739bfe;
                margin-bottom: 0.6rem;
                padding-left: 0.33rem;
                padding-top: 0.2rem;
                position: relative;
                font-size: 0.26rem;
                // //font-family:: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #4e4e4e;
                line-height: 0.44rem;
                text-align: left;
                padding-bottom: 0.35rem;

                .title-bg {
                    position: absolute;
                    width: 3.31rem;
                    height: 0.6rem;
                    top: -0.6rem;
                    left: -0.25rem;
                    display: inline-flex;
                    align-items: center;
                    font-size: 0.34rem;
                    // //font-family:: PingFang SC-Bold, PingFang SC;
                    font-weight: bold;
                    color: #3d5aa3;
                    padding-left: 0.58rem;
                    background: url(../assets/imgs/craft/part4-1.png);
                    background-size: 100% 100%;
                }

                .title-bg2 {
                    background: url(../assets/imgs/craft/part4-2.png);
                    background-size: 100% 100%;
                    white-space: nowrap;
                }

                .inside-title {
                    font-weight: 800;
                }

                // .part-four-content1 {
                //     // margin-bottom: 0.2rem;
                // }
                .part-four-content2 {
                    font-weight: bolder;
                }
            }
        }
    }

    .part-five {
        width: 6.85rem;
        // height: 1.17rem;
        background: #fff;
        margin-top: 0.32rem;
        border-radius: 10px;
        box-sizing: border-box;
        padding: 0.25rem;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 0.5rem;
        // //font-family:: PingFang SC-Heavy, PingFang SC;
        font-weight: 800;
        color: #2350bf;
    }

    .bottom-info {
        margin-top: 0.22rem;
        font-size: 0.24rem;
        // //font-family:: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #97a9d9;

        a {
            text-decoration: none;
            // color: #97a9d9;
        }
    }
}
</style>
